import { Button, DialogActions, DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilValue } from 'recoil';
import { I18n } from 'aws-amplify';
import { handleSubmitDeleteB2BCustomer } from '../handler/BusinessCustomerListInProjectHandler';

export default function ConfirmDeleteB2BCustomer(props) {
    const { isOpen, setIsOpen, selectedB2BCustomer, setSelectedB2BCustomer } = props;

    const handleAgree = () => {
        handleSubmitDeleteB2BCustomer(props, selectedB2BCustomer);
    };

    const handleDisagree = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setSelectedB2BCustomer({});
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => handleDisagree(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-delete-addition-user"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-delete-addition-user-content">
                    {I18n.get('USER09MSG010')}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="confirm-delete-user-dialog-action">
                <Button
                    onClick={handleAgree}
                    autoFocus
                    className="btn-handle-delete-user btn-handle-delete-user-agree"
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    onClick={handleDisagree}
                    className="btn-handle-delete-user btn-handle-delete-user-disagree"
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
